// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_br-2";
export var aiChatCartContainerExit = "_br-4";
export var aiChatContainerLarge = "_br-0";
export var aiChatContainerSmall = "_br-1";
export var aiChatIcon = "_br-6";
export var slideInFromRight = "_br-3";
export var slideOutToRight = "_br-5";